(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  function getCard(el) {
    return el.closest('.card-wrapper');
  }

  function getImg(card) {
    return card ? card.querySelector('.card__media .media img') : null;
  }

  function remember(img) {
    if (img.dataset.origSrc === undefined) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
  }

  function showSwatch(btn) {
    var card = getCard(btn);
    var img = getImg(card);
    if (!img || !btn.dataset.src) return;
    remember(img);
    img.setAttribute('srcset', btn.dataset.srcset || '');
    img.setAttribute('src', btn.dataset.src);
    card.classList.add('card-swatch-preview');
  }

  function restore(card) {
    var img = getImg(card);
    if (!img || img.dataset.origSrc === undefined) return;
    var selected = card.querySelector('.card-swatch.is-selected');
    if (selected && selected.dataset.src) {
      img.setAttribute('srcset', selected.dataset.srcset || '');
      img.setAttribute('src', selected.dataset.src);
    } else {
      img.setAttribute('srcset', img.dataset.origSrcset);
      img.setAttribute('src', img.dataset.origSrc);
      card.classList.remove('card-swatch-preview');
    }
  }

  function select(btn) {
    var card = getCard(btn);
    if (!card) return;
    card.querySelectorAll('.card-swatch.is-selected').forEach(function (b) {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
    if (btn.dataset.src) {
      showSwatch(btn);
    } else {
      restore(card);
    }
    if (btn.dataset.url) {
      card.querySelectorAll('a.full-unstyled-link[href]').forEach(function (a) {
        a.setAttribute('href', btn.dataset.url);
      });
    }
  }

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var btn = e.target.closest && e.target.closest('.card-swatch[data-src]');
      if (btn) showSwatch(btn);
    });
    document.addEventListener('mouseout', function (e) {
      var list = e.target.closest && e.target.closest('.card-swatches');
      if (!list) return;
      if (e.relatedTarget && list.contains(e.relatedTarget)) return;
      restore(getCard(list));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.card-swatch');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    select(btn);
  });
})();
